import React from 'react'

import Button from '../components/Button'
import Layout from '../components/Layout'
import Modal from '../components/Modal'
import Seo from '../components/Seo'
import Text from '../components/Text'
import Title from '../components/Title'
import * as View from '../views'

const IndexPage = () => (
  <Layout>
    <Seo title="Curso: A nova cozinha nordestina" />
    <View.Intro />
    <View.About />
    <View.Testimony />
    <View.Modules />
    <View.Ebook />
    <View.Buy />
    <View.Chef />

    <Modal centered>
      <div className="t-center">
        <Title
          size={18}
          color="primary"
          appearance="form"
          marginBottom={12}
          className="t-center"
        >
          Período de venda exclusivo para o pacote promocional.
        </Title>
        <Text color="primary" size={16} marginBottom={24}>
          Módulos individuais liberados em 06 de Julho
        </Text>
        <Button
          target="_blank"
          href="https://pay.hotmart.com/N37277066I?checkoutMode=0&bid=1593475180852"
          title="Quero comprar"
          color="primary"
          fluid
        >
          SEGUIR PARA PACOTE MÓDULOS II & III
        </Button>
      </div>
    </Modal>
  </Layout>
)

export default IndexPage
